import * as React from "react";
import { GetServerSideProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { NextPage } from "next";
import bg from "@images/service.png";
import Layout from "@/components/layout";
import Image from "next/image";
import styles from "./index.module.scss";
import Head from 'next/head'
const PrivacyPolicy: NextPage<{
  context: any;
}> = (props) => {
  return (
    <div>
            <Head>
        <title>Terms of Service | TikTok Analytics Tool | Shoplus</title>
        <meta name="keywords" content="TikTok analytics, influencer marketing" />
        <meta
          name="description"
          content="Read this terms of service to know about the TikTok analytics tool-Shoplus."
        />
      </Head>
      <Layout header={true} footer={true}>
        <div className={styles.service}>
          <div className="defeaultContainer">
            <div className={styles.header}>
              <div className={styles.text}>
                <h1 className={styles.title}>Terms of Service</h1>
                <h2 className={styles.tip}>
                  Read our terms below to learn more about your
                  <br />
                  rights and responsibilities as a Shoplus user.
                </h2>
              </div>
              <div className={styles.img}>
                <Image src={bg} alt="Terms of Service"></Image>
              </div>
              <div className={styles.bg}></div>
            </div>

            <div className={styles.sign}>May 1, 2022:</div>
            <div className={styles.content}>
              <div className={styles["content-setion"]}>
                <h3 className={styles["content-title"]}>Overview</h3>
                <span className={styles["content-tip"]}>
                  {`Shoplus.net (hereinafter referred to as "Shoplus" or "we")
                  provides services to you through its website at
                  www.shoplus.net (collectively, these services, including any
                  new features and applications, and the website). Subject to
                  the following services Terms are binding. The Service was
                  created to provide analytical and statistical tools related to
                  TikTok usage. We reserve the right, in our sole discretion, to
                  change or modify portions of these Terms of Service at any
                  time without notice. You should periodically visit this page
                  to review the current Terms of Service for any amendments to
                  which you are bound.`}
                  <div className="h-[12px]"></div>
                  {`Our Privacy Policy also governs your use of our services and
                  explains how we collect, protect and disclose information
                  arising from your use of our web pages. Your agreement with us
                  includes these terms. You acknowledge that you have read and
                  understood the Terms and agree to be bound by them. You have
                  also read our Privacy Policy. Violation of any of the above
                  terms will result in termination of your account.`}
                </span>
              </div>
              <div className={styles["content-setion"]}>
                <h3 className={styles["content-title"]}>1. Service</h3>
                <span className={styles["content-tip"]}>
                  Shoplus provides analytics and reporting solutions to help
                  people collect and analyze data on TikTok.
                </span>
              </div>
              <div className={styles["content-setion"]}>
                <h3 className={styles["content-title"]}>2. Qualification</h3>
                <span className={styles["content-tip"]}>
                  {`You must be at least 18 years old to use this service.
                  Shoplus is not responsible for any misrepresentation of age.
                  By using this platform, you certify and warrant that all data
                  provided by you is true and correct. Accounts registered using
                  "robots" or other automated methods are not permitted.`}
                </span>
              </div>
              <div className={styles["content-setion"]}>
                <h3 className={styles["content-title"]}>3. Communication</h3>
                <span className={styles["content-tip"]}>
                  By using our Services, you agree to subscribe to newsletters,
                  marketing or promotional materials, and other communications
                  we may send. However, you may opt out of receiving any or all
                  of these communications from us by clicking on the unsubscribe
                  link or by emailing marketing@Shoplus.net. Account
                  Registration and Use Restrictions
                  <div className="h-[12px]"></div>
                  An account is only permitted to subscribe to one plan at any
                  given time, and you must provide any required information
                  requested to complete the registration process.
                  <div className="h-[12px]"></div>
                  You are responsible for maintaining the security of your
                  account and password. Shoplus shall not be liable for any
                  loss or damage arising from your failure to comply with this
                  security obligation. No one can access your account without
                  your login credentials, including the Shoplus team
                  <div className="h-[12px]"></div>
                  You are responsible for all activity that occurs under your
                  account, including persons you grant access to your account
                  (including subscription upgrades).
                  <div className="h-[12px]"></div>
                  You may not use the Services for any illegal or unauthorized
                  purpose. Your use of the Service must not violate any laws in
                  your jurisdiction.
                  <div className="h-[12px]"></div>
                  {`You may not use the Services to track or analyze tags that
                  Shoplus, in its sole discretion, deems illegal, harmful,
                  threatening, abusive, harassing, tortious, excessively
                  violent, defamatory, vulgar, obscene, pornographic,
                  slanderous, invasive of another's privacy, hateful, racially
                  biased, racially biased , sexual bias, or otherwise
                  objectionable content, at our sole discretion.`}
                </span>
              </div>
              <div className={styles["content-setion"]}>
                <h3 className={styles["content-title"]}>4. Fees and Payments</h3>
                <span className={styles["content-tip"]}>
                  If you wish to purchase any product or service offered through
                  the Services (“Purchase”), you may be asked to provide certain
                  information in connection with your purchase, including but
                  not limited to your credit or debit card number, your card
                  expiration date, and your billing address. You will promptly
                  update your information if there are any changes (for example,
                  a change to your billing address or credit card expiration
                  date).
                  <div className="h-[12px]"></div>
                  When you purchase any Paid Services, you authorize Shoplus, or
                  its third party payment processors, to charge your nominated
                  credit card (to which you represent and warrant that you have
                  the right to use) all applicable charges for your purchases in
                  U.S. dollars, and you agree that Shoplus, Inc. or its
                  third-party payment processors may store your credit card
                  information. By subscribing, you allow Shoplus to charge your
                  card for payments for your subscription and future payments in
                  accordance with our Terms of Service
                  <div className="h-[12px]"></div>
                  At the end of each billing cycle, your subscription will
                  automatically renew under the exact same terms, unless you
                  cancel your subscription. Shoplus does not issue refunds once
                  the transaction is complete. If automatic billing fails for
                  any reason, Shoplus reserves the right to terminate your
                  access to the Services immediately.
                  <div className="h-[12px]"></div>
                  For plans purchased with a monthly billing cycle, your monthly
                  effective billing date is the day of the month in which you
                  originally signed up and paid for your Shoplus account. You
                  will be billed for your service level on the same day each
                  month.
                  <div className="h-[12px]"></div>
                  For plans purchased on an annual billing cycle, your effective
                  annual billing date is the year you originally signed up and
                  paid for your Shoplus account. You will be billed the annual
                  fee on the same date each year in the amount indicated by your
                  Service Level.
                  <div className="h-[12px]"></div>
                  Depending on the plan you purchased, you are entitled to
                  features and limitations such as: https://shoplus.net/pricing
                </span>
              </div>
              <div className={styles["content-setion"]}>
                <h3 className={styles["content-title"]}>
                  5. Data and Account Level
                </h3>
                <span className={styles["content-tip"]}>
                  Your data is held by the Shoplus service for as long as you
                  maintain a subscription (paid) account.
                </span>
              </div>
              <div className={styles["content-setion"]}>
                <h3 className={styles["content-title"]}>
                  6. Service Level Agreements and Downtime
                </h3>
                <span className={styles["content-tip"]}>
                  We will make reasonable efforts to provide users with the best
                  product service level. For this reason, we may conduct
                  irregular system maintenance, upgrades and backups, and
                  temporarily suspend use to improve long-term user experience.
                  Social media platforms regularly update and change their
                  algorithms, systems and platforms. During such events,
                  Shoplus.net will require development time to actively and
                  timely adapt to such changes in order to adapt the services
                  offered. We will use reasonable efforts to provide you with
                  the best service, so there may be system maintenance, backup
                  and upgrade functions that may affect the function, and the
                  downtime is calculated in days.
                </span>
              </div>
              <div className={styles["content-setion"]}>
                <h3 className={styles["content-title"]}>7. General situation</h3>
                <span className={styles["content-tip"]}>
                  You may not transmit any viruses or any code of any
                  destructive nature.
                  <div className="h-[12px]"></div>
                  You understand that Shoplus uses third party vendors and
                  hosting partners to provide the necessary hardware, software,
                  networking, storage and related technology required to run the
                  Services.
                  <div className="h-[12px]"></div>
                  You understand that the technical processing and transmission
                  of the Services, including Your Content, may be transmitted,
                  unencrypted and involve (a) transmission over various
                  networks; (b) changes to conform and adapt to the technical
                  requirements of connecting networks or devices.
                  <div className="h-[12px]"></div>
                  You agree not to reproduce, reproduce, copy, sell, resell or
                  exploit any part of the Services, use the Services or access
                  the Services without the express written consent of Shoplus.
                  <div className="h-[12px]"></div>
                  TikTok makes changes to its algorithm from time to time, so
                  Shoplus.net needs to be retuned to generate analytics and
                  insights for you. Occasional outages due to TikTok’s algorithm
                  adjustments may cause discrepancies in the social insights
                  analyzed and Shoplus.net may need to recalibrate as
                  necessary.
                  <div className="h-[12px]"></div>
                  Our customer service hours are Monday to Friday, 9:30 am to
                  18:30 pm, China time
                  <div className="h-[12px]"></div>
                  You understand, acknowledge and agree that other services and
                  suppliers connected to the Shoplus platform to provide our
                  services may experience unforeseen issues that may affect the
                  Shoplus platform from time to time. Shoplus may not be liable
                  for such performance issues including, but not limited to,
                  payments for the Shoplus Platform/Services.
                </span>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { locale } = context;
  return {
    props: {
      ...(await serverSideTranslations(locale as string, [
        "home",
        "common",
        "nav",
        "footer",
      ])),
      context: {
        locale,
        req: {
          headers: context.req.headers,
        },
      },
    },
  };
};
export default PrivacyPolicy;
